export const BLANK = '(Blank)';

export const prepareColumnDataWithBlank = (
    items: string[],
    query: string,
) => {
    const hasBlank = query.length === 0 && items.some(item => item.length === 0);
    const displayedColumnData = hasBlank ? [BLANK, ...items] : [...items];

    return {hasBlank, displayedColumnData};
};
